import { Box } from '@material-ui/core';
import { Tooltip } from '@roc/ui';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  icon: {
    minWidth: '20px',
    height: '20px',
    lineHeight: '18px',
    padding: '0 3px',
    textAlign: 'center',
    fontWeight: 'bold',
    borderRadius: '3px',
    fontSize: '12px',
    border: '1px solid',
  },
  closingCondition: {
    borderColor: 'orange',
    color: 'orange',
  },
  postClosingCondition: {
    borderColor: '#2e6da4',
    color: '#2e6da4',
  },
}));

export const ClosingConditionIcon = () => {
  const classes = useStyles();
  return (
    <Tooltip title="Closing Condition">
      <Box className={`${classes.icon} ${classes.closingCondition}`}>CC</Box>
    </Tooltip>
  );
};

export const PostClosingConditionIcon = () => {
  const classes = useStyles();
  return (
    <Tooltip title="Post Closing Condition">
      <Box className={`${classes.icon} ${classes.postClosingCondition}`}>
        PC
      </Box>
    </Tooltip>
  );
};
